import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OrganizationConfig } from '../../../../models/organization-config.model';

@Component({
    standalone: false,
    selector: 'por-admin-images',
    templateUrl: './admin-images.component.html',
    styleUrls: ['./admin-images.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminImagesComponent {
    @Input() config!: OrganizationConfig;
}
